export default {"src":"/_next/static/media/youtube.701f226d.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};